import type { RoutingContext } from '@/overmind/effects/router';

import type { Context } from '../../../overmind';
import { routes } from '../../../overmind/machines/router';

export const handleHomeRouteWithTenantId = (context: Context) => ({
  [routes.rootWithTenantId]: async ({ params }: RoutingContext) => {
    await context.actions.handleHomeRouteWithTenantId(params);
  }
});
